module.exports = __webpack_public_path__ + "pointti_logo-4e1779fd234ab45f2b56.png";